import React, { useRef, useMemo } from "react";
import { Spin, Typography, Alert as AlertAntd } from "antd";
import { JoinedAlert } from "../../../types";
import { useListTrapSitesQuery } from "../../../actions/trapsiteInQuery";
import { useListDevicesQuery } from "../../../actions/devicesInQuery";
import { DownOutlined } from "@ant-design/icons";
import ArchiveBoxIcon from "@heroicons/react/24/outline/ArchiveBoxIcon";
import AlertDialog from "./AlertDialog";
import "./index.css";
import { useAppAlerts } from "../../../hooks/useAppAlerts";

const { Text, Title } = Typography;

type Props = {
  // Extra props go here
};

const TrapAlert: React.FC<Props> = () => {
  const listContainerRef = useRef<HTMLDivElement>(null);

  const { data: trapSitesData, isLoading: isTrapSiteLoading } =
    useListTrapSitesQuery();
  const { data: devices, isLoading: isDevicesLoading } = useListDevicesQuery();
  const { data: alerts } = useAppAlerts();

  const joinedAlerts = useMemo(() => {
    if (!alerts?.items) {
      return [];
    }

    let result: JoinedAlert[] = [];

    alerts?.items.forEach((alert) => {
      if (!(alert.severity === "danger")) {
        return;
      }

      const device = devices?.items?.find((d) => d.uuid === alert.device);
      const trapsite = trapSitesData?.items?.find((t) => {
        return t._id === device?.trap_id;
      });
      result.push({
        ...alert,
        device_name: device?.display_name || "",
        trap_name: trapsite?.display_name || "",
      });
    });

    return result;
  }, [alerts, devices, trapSitesData]);

  const offlineCount = useMemo(() => {
    return (
      devices?.items?.filter(
        (device) => (device?.status || "offline").toLowerCase() !== "online",
      )?.length || 0
    );
  }, [devices]);

  return (
    <div className="detection-box-container">
      <Spin spinning={isTrapSiteLoading || isDevicesLoading}>
        <div className="detection-box-title">
          <Title level={4} className="detection-box-title-text">
            Traps
          </Title>
          <DownOutlined className="detection-box-title-icon" />
        </div>
        <div
          ref={listContainerRef}
          className={`detection-box-alerts ${
            joinedAlerts.length > 0 ? "has-alerts" : "no-alerts"
          }`}
        >
          <AlertAntd
            message={
              <Text strong>
                {offlineCount === 0
                  ? "All Devices Online"
                  : `${offlineCount} Device Off`}
              </Text>
            }
            showIcon
            type={offlineCount === 0 ? "success" : "error"}
            icon={<ArchiveBoxIcon width={24} height={24} />}
            className="status-devices"
          />
          {joinedAlerts.length > 0 &&
            joinedAlerts.map((item: JoinedAlert) => (
              <AlertDialog
                key={item._id}
                item={item}
                //   onClick={doUpdateAlert}
              />
            ))}
        </div>
      </Spin>
    </div>
  );
};

export default TrapAlert;
